const CommonItemEventParams = {
  item_id: "item_id",
  item_name: "item_name",
  item_price: "item_price",
  item_count: "item_count",
  store_name: "store_name",
  store_id: "store_id",
  movement_type: "movement_type",
  sector: "sector",
  terminal: "terminal",
  domain: "domain",
  fulfilment_type: "fulfilment_type",
  delivery_time: "delivery_time",
  delivery_time_ms: "delivery_time_ms",
  preference_available: "preference_available",
  preference_selected: "preference_selected",
  preference_price: "preference_price",
  updated_quantity: "updated_quantity",
  type: "type",
  triggerPoint: {
    trigger_point: () => window.location.pathname.split("/")[1],
  },
};
const { updated_quantity, type, ...CartViewedItemParams } = CommonItemEventParams;
const { item_count, domain, fulfilment_type, ...ProceedToPayBaseParams } = CartViewedItemParams;

export const EventParams = {
  kiosk_cart_viewed: {
    ...CartViewedItemParams,
    item_size: "item_size",
    sub_total: "sub_total",
    convenience_fee: "convenience_fee",
    taxes: "taxes",
    total: "total",
  },
  kiosk_proceed_to_pay: {
    ...ProceedToPayBaseParams,
    sub_total: "sub_total",
    discounts: "discounts",
    convenience_fee: "convenience_fee",
    taxes: "taxes",
    total: "total",
  },
  kiosk_quick_sign_in: {
    timestamp: "timestamp",
    UserId: "UserId",
    name: "name",
    type: "type",
    lmsmemberid: "lmsmemberid",
  },
  kiosk_payment_successful: {
    order_id: "order_id",
    store_name: "store_name",
    store_id: "store_id",
    item_name: "item_name",
    item_id: "item_id",
    item_quantity: "item_quantity",
    item_price: "item_price",
    movement_type: "movement_type",
    sector: "sector",
    terminal: "terminal",
    total: "total",
    sub_total: "sub_total",
    discount: "discount",
    taxes: "taxes",
    packaging_charges: "packaging_charges",
    domain: "domain",
    delivery_time: "delivery_time",
    delivery_time_ms: "delivery_time_ms",
    fulfilment_type: "fulfilment_type",
    payment_mode: "payment_mode",
  },
  kiosk_payment_failed: {
    item_name: "item_name",
    item_price: "item_price",
    store_name: "store_name",
    domain: "domain",
    movement: "movement",
    sector: "sector",
    terminal: "terminal",
    pickup: "pickup",
    drop: "drop",
    delivery_times: "delivery_times",
    delivery_times_ms: "delivery_times_ms",
    total: "total",
    sub_total: "sub_total",
    discount: "discount",
    taxes: "taxes",
    packaging_charges: "packaging_charges",
    orderId: "orderId",
    reason: "reason",
  },
  kiosk_filter_applied: {
    filter_value: "filter_value",
    domain: "domain",
  },
};

export const mapEventData = (event_name, data) => {
  const eventData = {};
  const eventParams = EventParams[event_name];

  if (!eventParams) {
    return data;
  }

  for (const [key, value] of Object.entries(eventParams)) {
    if (key === "customLogic") {
      for (const [customKey, customFunc] of Object.entries(value)) {
        eventData[customKey] = customFunc(data);
      }
    } else if (key === "triggerPoint") {
      for (const [triggerKey, triggerFunc] of Object.entries(value)) {
        eventData[triggerKey] = data[triggerKey] !== undefined ? data[triggerKey] : triggerFunc();
      }
    } else {
      if (Array.isArray(value)) {
        const foundValue = value.find((v) => data[v] !== undefined);
        if (foundValue) {
          eventData[key] = data[foundValue];
        }
      } else {
        eventData[key] = data[value];
      }
    }
  }
  return eventData;
};

export const getPriceArrayFromPreference = (preference) => {
  const priceArray = [];
  if (!preference || preference.length === 0) {
    return priceArray;
  }
  preference.forEach((pref) => {
    pref?.selection?.forEach((sel) => {
      priceArray.push(sel?.price);
    });
  });
  return priceArray;
};

export const getTitleArrayFromPreference = (preference) => {
  const titleArray = [];
  if (!preference || preference.length === 0) {
    return titleArray;
  }
  preference.forEach((pref) => {
    pref?.selection?.forEach((sel) => {
      titleArray.push(`${pref?.title}: ${sel?.name}`);
    });
  });
  return titleArray;
};

export const getSizeFromPreference = (preference, customisationAttributes) => {
  let sizeStr = "";

  if (customisationAttributes) {
    if (Array.isArray(customisationAttributes)) {
      customisationAttributes.forEach((attr) => {
        if (attr?.attributeName?.toLowerCase() === "size") {
          if (attr?.value?.length > 0) {
            sizeStr = attr.value[0];
          } else if (attr?.attributeValues?.length > 0) {
            sizeStr = attr.attributeValues[0]?.attributeValue;
          }
        }
      });
    } else if (typeof customisationAttributes === 'object') {
      Object.keys(customisationAttributes).forEach((key) => {
        if (key.toLowerCase() === "size" && customisationAttributes[key]?.length > 0) {
          sizeStr = customisationAttributes[key][0];
        }
      });
    }
  }

  if (sizeStr) return sizeStr;

  if (!preference || preference.length === 0) {
    return sizeStr;
  }
  preference.forEach((pref) => {
    pref?.selection?.forEach((sel) => {
      if (sel?.price > 0) {
        sizeStr = sel?.name;
      }
    });
  });

  if (!sizeStr) {
    preference.forEach((pref) => {
      if (pref?.title?.toLowerCase() === "size") {
        pref?.selection?.forEach((sel) => {
          sizeStr = sel?.name;
        });
      }
    });
  }
  return sizeStr;
};

export const getEventDataFromOrderSummary = (orderSummary) => {
  const eventData = {
    item_names: [],
    item_prices: [],
    store_names: [],
    domains: [],
    movements: [],
    sectors: [],
    terminals: [],
    pickup: [],
    drop: [],
    delivery_times: [],
    delivery_times_ms: [],
  };

  orderSummary.data.forEach((item) => {
    const store = item?.shopName;
    const itemName = item?.title;
    const price = item?.price?.amount;
    const storeInfo = item?.storeInfo || item?.vendorInfo;
    const deliveryTime = item?.delivery?.itemEstimatedDeliveryTime;

    let domain = "Unknown";
    let movement = "Unknown";
    let sector = "Unknown";
    let terminal = "Unknown";
    let pickup = "Unknown";
    let drop = "Unknown";

    eventData.item_names.push(itemName);
    eventData.item_prices.push(price);
    eventData.store_names.push(store);
    eventData.delivery_times.push(deliveryTime);
    eventData.delivery_times_ms.push(new Date(deliveryTime).getTime());

    if (storeInfo) {
      domain = storeInfo?.domain;

      if (storeInfo?.location) {
        movement = storeInfo?.location?.toLowerCase().includes("depart")
          ? "Departure"
          : "Arrival";
        sector = storeInfo?.location?.toLowerCase().includes("domestic")
          ? "Domestic"
          : "International";
        terminal = storeInfo?.terminal?.value;
      }
    }

    if (item?.metadata?.drop) {
      drop = item?.metadata?.drop?.address;
    }
    if (item?.metadata?.pickup) {
      pickup = item?.metadata?.pickup?.address;
    }

    eventData.domains.push(storeInfo?.domain);
    eventData.movements.push(movement);
    eventData.sectors.push(sector);
    eventData.terminals.push(terminal);
    eventData.pickup.push(pickup);
    eventData.drop.push(drop);
  });

  const priceInfo = orderSummary?.metadata?.priceInfo;
  eventData["total"] = priceInfo?.total;
  eventData["sub_total"] = priceInfo?.subtotal;
  eventData["discounts"] = priceInfo?.discounts;
  eventData["taxes"] = priceInfo?.taxes;
  eventData["packaging_charges"] = priceInfo?.packagingCharges;

  return eventData;
};

export const flatAndMapEventData = (event_name, data) => {
  const processStore = (store) => {
    const { items, ...restFields } = store;
    return items.map((item) => ({
      ...item,
      ...restFields,
    }));
  };

  // Handle both array and JSON object cases
  const flattenedItems = Array.isArray(data)
    ? data.flatMap(processStore)
    : Object.values(data).flatMap(processStore);

  if (flattenedItems.length <= 1) {
    return mapEventData(event_name, flattenedItems[0]);
  }

  const combinedObject = {};
  flattenedItems.forEach((item) => {
    const mappedData = mapEventData(event_name, item);
    Object.entries(mappedData).forEach(([key, value]) => {
      if (!combinedObject[key]) {
        combinedObject[key] = [];
      }
      combinedObject[key].push(value);
    });
  });
  return combinedObject;
};

